(() => {
  const initializeRecipes = (root) => {
    const section = root.matches?.('[data-tromba-recipes]') ? root : root.querySelector?.('[data-tromba-recipes]');
    if (!section || section.dataset.recipesReady === 'true') return;
    section.dataset.recipesReady = 'true';

    const cards = Array.from(section.querySelectorAll('[data-recipe-grid] [data-recipe-card]'));
    const filters = Array.from(section.querySelectorAll('[data-recipe-filter]'));
    const results = section.querySelector('[data-recipe-results]');
    const empty = section.querySelector('[data-recipe-empty]');

    const setResults = (count) => {
      if (!results) return;
      const template = results.dataset.resultsTemplate || '[count] recipes';
      results.textContent = template.replace('[count]', String(count));
    };

    const applyFilter = (field, value, activeButton) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const haystack = field === 'search'
          ? card.dataset.recipeSearch || ''
          : field === 'category'
            ? card.dataset.recipeCategory || ''
            : card.dataset.recipeTequila || '';
        const visible = value === 'all' || haystack.includes(value);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      filters.forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      setResults(visibleCount);
      if (empty) empty.hidden = visibleCount !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.filterField || 'all', button.dataset.filterValue || 'all', button);
      });
    });

    section.querySelectorAll('[data-expression-filter]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const value = link.dataset.expressionFilter;
        const targetFilter = filters.find((button) =>
          button.dataset.filterField === 'tequila' && button.dataset.filterValue === value
        );
        if (!targetFilter) return;
        event.preventDefault();
        targetFilter.click();
        section.querySelector('[data-recipe-grid]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const initialFilter = filters.find((button) => button.classList.contains('is-active')) || filters[0];
    if (initialFilter) {
      applyFilter(initialFilter.dataset.filterField || 'all', initialFilter.dataset.filterValue || 'all', initialFilter);
    } else {
      setResults(cards.length);
    }
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll?.('[data-tromba-recipes]').forEach(initializeRecipes);
    initializeRecipes(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
